/**
 * Prize Popup JavaScript
 * Handles popup display, form submission, and user interactions
 */

(function() {
  'use strict';

  const CONFIG = {
    API_BASE_URL: 'https://odoo-inbound.vercel.app/api/contact',
    BRAND: 'Zengaz',
    BRAND_NAME: 'Zengaz',
    STORAGE_KEY: 'zengaz_popup_shown',
  };

  // intl-tel-input instance and country mapping
  let itiInstance = null;
  const countryNameToIso2 = {};

  function buildCountryNameMap() {
    if (typeof intlTelInput === 'undefined') return;
    const countryData = intlTelInput.getCountryData ? intlTelInput.getCountryData() :
                        (window.intlTelInputGlobals ? window.intlTelInputGlobals.getCountryData() : []);
    countryData.forEach((c) => {
      const cleanName = c.name.replace(/\s*\(.*\)/, '').trim().toLowerCase();
      countryNameToIso2[cleanName] = c.iso2;
      countryNameToIso2[c.name.toLowerCase()] = c.iso2;
    });
    // Manual overrides for common mismatches
    Object.assign(countryNameToIso2, {
      'bolivia': 'bo', 'brunei': 'bn', 'congo': 'cg',
      'democratic republic of the congo': 'cd', 'falkland islands': 'fk',
      'iran': 'ir', 'ivory coast': 'ci', "cote d'ivoire": 'ci',
      'north korea': 'kp', 'south korea': 'kr', 'laos': 'la',
      'libya': 'ly', 'macedonia': 'mk', 'macedonia (fyrom)': 'mk',
      'micronesia': 'fm', 'moldova': 'md', 'palestine': 'ps',
      'russia': 'ru', 'saint helena': 'sh', 'syria': 'sy',
      'taiwan': 'tw', 'tanzania': 'tz', 'venezuela': 've',
      'vietnam': 'vn', 'british virgin islands': 'vg',
      'u.s. virgin islands': 'vi', 'myanmar (burma)': 'mm',
      'türkiye': 'tr', 'east timor': 'tl', 'vatican city': 'va',
      'kosovo': 'xk', 'swaziland': 'sz', 'cape verde': 'cv',
    });
  }

  function getIso2FromCountryName(name) {
    if (!name) return '';
    const lower = name.toLowerCase().trim();
    if (countryNameToIso2[lower]) return countryNameToIso2[lower];
    // Fuzzy fallback
    const keys = Object.keys(countryNameToIso2);
    for (let i = 0; i < keys.length; i++) {
      if (keys[i].indexOf(lower) !== -1 || lower.indexOf(keys[i]) !== -1) {
        return countryNameToIso2[keys[i]];
      }
    }
    return '';
  }

  function initIntlTelInput() {
    if (typeof intlTelInput === 'undefined') return;
    buildCountryNameMap();

    const phoneInput = document.getElementById('popupPhone');
    if (!phoneInput) return;

    itiInstance = intlTelInput(phoneInput, {
      initialCountry: 'auto',
      geoIpLookup: (successCallback) => {
        fetch('https://ipapi.co/json/')
          .then((resp) => resp.json())
          .then((data) => successCallback((data && data.country) ? data.country : 'us'))
          .catch(() => successCallback('us'));
      },
      utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js',
      nationalMode: true,
      formatOnDisplay: true,
      autoPlaceholder: 'aggressive',
    });

    // Sync: when intl-tel-input country changes, update the country select
    phoneInput.addEventListener('countrychange', () => {
      const selectedData = itiInstance.getSelectedCountryData();
      if (!selectedData || !selectedData.iso2) return;
      const countrySelect = document.getElementById('popupCountry');
      if (!countrySelect) return;
      // Never override a country the visitor already chose
      if (countrySelect.value) return;
      const iso2 = selectedData.iso2;
      for (let i = 0; i < countrySelect.options.length; i++) {
        if (String(countrySelect.options[i].value).toLowerCase() === iso2) {
          countrySelect.value = countrySelect.options[i].value;
          countrySelect.classList.remove('is-invalid');
          const label = countrySelect.previousElementSibling;
          if (label) label.classList.remove('is-invalid');
          break;
        }
      }
    });

    // Phone validation on blur
    phoneInput.addEventListener('blur', () => {
      validatePhoneField();
    });

    // Re-validate on input if already invalid
    phoneInput.addEventListener('input', () => {
      if (phoneInput.classList.contains('is-invalid')) {
        validatePhoneField();
      }
    });
  }

  function validatePhoneField() {
    const phoneInput = document.getElementById('popupPhone');
    if (!phoneInput) return true;
    const label = phoneInput.closest('.form-field')?.querySelector('.form-label');
    const phoneError = phoneInput.closest('.form-field')?.querySelector('.popup-phone-error');
    const value = phoneInput.value.trim();

    if (!value) {
      phoneInput.classList.add('is-invalid');
      if (label) label.classList.add('is-invalid');
      if (phoneError) { phoneError.textContent = 'This field is required'; phoneError.style.display = 'block'; }
      return false;
    }

    if (itiInstance && !itiInstance.isValidNumber()) {
      phoneInput.classList.add('is-invalid');
      if (label) label.classList.add('is-invalid');
      if (phoneError) { phoneError.textContent = 'Please enter a valid phone number'; phoneError.style.display = 'block'; }
      return false;
    }

    phoneInput.classList.remove('is-invalid');
    if (label) label.classList.remove('is-invalid');
    if (phoneError) phoneError.style.display = 'none';
    return true;
  }

  function setupCountrySelectSync() {
    const countrySelect = document.getElementById('popupCountry');
    if (!countrySelect) return;
    countrySelect.addEventListener('change', () => {
      const iso2 = String(countrySelect.value).toLowerCase();
      if (iso2 && itiInstance) {
        itiInstance.setCountry(iso2);
      }
    });
  }

  const PopupManager = {
    state: {
      userType: null,
      delaySeconds: 2,
      showOnce: true,
    },

    $(id) {
      return document.getElementById(id);
    },

    capitalize(str) {
      if (!str) return '';
      return str.replace(/\b\w/g, (char) => char.toUpperCase());
    },

    show(element) {
      if (typeof element === 'string') element = this.$(element);
      if (element) element.style.display = 'block';
    },

    hide(element) {
      if (typeof element === 'string') element = this.$(element);
      if (element) element.style.display = 'none';
    },

    showView(viewToShow) {
      this.hide('zengaz-popup-user-type-view');
      this.hide('zengaz-popup-form-view');
      this.hide('zengaz-popup-success-view');
      this.hide('zengaz-popup-business-success-view');
      this.show(viewToShow);
    },

    setFormFieldsDisabled(disabled) {
      const fields = ['popupFirstName', 'popupLastName', 'popupEmail', 'popupPhone', 'popupCountry', 'zengaz-popup-back-btn'];
      fields.forEach((id) => {
        const field = this.$(id);
        if (field) field.disabled = disabled;
      });

      const radioButtons = document.querySelectorAll('input[name="user_type"]');
      radioButtons.forEach((radio) => (radio.disabled = disabled));

      const form = this.$('zengaz-popup-form');
      const submitButton = form?.querySelector('button[type="submit"]');
      if (submitButton) submitButton.disabled = disabled;

      if (form) {
        form.style.opacity = disabled ? '0.6' : '1';
        form.style.pointerEvents = disabled ? 'none' : 'auto';
      }
    },

    init() {
      this.loadSettings();
      this.loadCountries();
      this.setupEventListeners();
      this.setupNameCapitalization();
      this.schedulePopup();
    },

    loadSettings() {
      // Get settings from section
      const popupSection = document.querySelector('[data-section-type="prize-popup"]');
      if (popupSection) {
        const delayAttr = popupSection.getAttribute('data-delay-seconds');
        const showOnceAttr = popupSection.getAttribute('data-show-once');

        if (delayAttr) this.state.delaySeconds = parseInt(delayAttr, 10);
        if (showOnceAttr) this.state.showOnce = showOnceAttr === 'true';
      }
    },

    schedulePopup() {
      // Check if popup should be shown
      if (this.state.showOnce && sessionStorage.getItem(CONFIG.STORAGE_KEY)) {
        console.log('[Popup] Already shown in this session');
        return;
      }

      // Show popup after delay
      const delay = this.state.delaySeconds * 1000;
      setTimeout(() => {
        this.showPopup();
      }, delay);
    },

    async loadCountries() {
      const countrySelect = this.$('popupCountry');
      if (!countrySelect) return;

      const countries = (window.ODOO_COUNTRIES || []); // [[ISO code, Odoo name], ...]

      countries.forEach((country) => {
        const option = document.createElement('option');
        option.value = country[0]; // ISO code
        option.textContent = country[1];
        countrySelect.appendChild(option);
      });

      // Initialize intl-tel-input after countries are loaded
      initIntlTelInput();
      setupCountrySelectSync();
    },

    setupNameCapitalization() {
      const firstNameInput = this.$('popupFirstName');
      const lastNameInput = this.$('popupLastName');

      if (firstNameInput) {
        firstNameInput.addEventListener('input', () => {
          const start = firstNameInput.selectionStart;
          const end = firstNameInput.selectionEnd;
          firstNameInput.value = this.capitalize(firstNameInput.value);
          firstNameInput.setSelectionRange(start, end);
        });
      }

      if (lastNameInput) {
        lastNameInput.addEventListener('input', () => {
          const start = lastNameInput.selectionStart;
          const end = lastNameInput.selectionEnd;
          lastNameInput.value = this.capitalize(lastNameInput.value);
          lastNameInput.setSelectionRange(start, end);
        });
      }
    },

    setupEventListeners() {
      const closeButton = this.$('zengaz-popup-close');
      const backButton = this.$('zengaz-popup-back-btn');
      const businessSuccessCloseButton = this.$('zengaz-business-success-close-btn');
      const popupForm = this.$('zengaz-popup-form');
      const popupOverlay = this.$('zengaz-popup-overlay');

      if (closeButton) closeButton.addEventListener('click', () => this.hidePopup());
      if (businessSuccessCloseButton) businessSuccessCloseButton.addEventListener('click', () => this.hidePopup());

      if (popupOverlay) {
        popupOverlay.addEventListener('click', (event) => {
          if (event.target === popupOverlay) this.hidePopup();
        });
      }

      // Handle user type selection
      document.querySelectorAll('input[name="user_type"]').forEach((radio) => {
        radio.addEventListener('change', () => {
          this.state.userType = radio.value;
          this.hide('zengaz-user-type-error');
          this.updateFormText();
          this.showView('zengaz-popup-form-view');
        });
      });

      if (backButton) backButton.addEventListener('click', () => this.showView('zengaz-popup-user-type-view'));

      if (popupForm) {
        popupForm.addEventListener('submit', (event) => this.handleSubmit(event));

        // Real-time validation on blur (skip phone — handled by intl-tel-input)
        const formInputs = popupForm.querySelectorAll('input, select');
        formInputs.forEach((input) => {
          if (input.type === 'tel') return;

          input.addEventListener('blur', () => {
            const label = input.previousElementSibling;
            if (!input.value || !input.value.trim()) {
              input.classList.add('is-invalid');
              if (label) label.classList.add('is-invalid');
            } else {
              input.classList.remove('is-invalid');
              if (label) label.classList.remove('is-invalid');
            }

            // Email validation
            if (input.id === 'popupEmail' && input.value && input.value.trim()) {
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(input.value)) {
                input.classList.add('is-invalid');
                if (label) label.classList.add('is-invalid');
              }
            }
          });

          // Remove validation on input if field becomes valid
          input.addEventListener('input', () => {
            if (input.classList.contains('is-invalid') && input.value && input.value.trim()) {
              input.classList.remove('is-invalid');
              const label = input.previousElementSibling;
              if (label) label.classList.remove('is-invalid');
            }
          });
        });
      }
    },

    updateFormText() {
      const consumerFormText = this.$('zengaz-popup-form-text-consumer');
      const businessFormText = this.$('zengaz-popup-form-text-business');

      if (this.state.userType === 'Consumer') {
        this.show(consumerFormText);
        this.hide(businessFormText);
      } else {
        this.hide(consumerFormText);
        this.show(businessFormText);
      }
    },

    showPopup() {
      const popupOverlay = this.$('zengaz-popup-overlay');
      if (popupOverlay) {
        popupOverlay.style.display = 'flex';

        // Lock body scroll
        document.body.classList.add('popup-open');

        // Mark as shown in session storage
        if (this.state.showOnce) {
          sessionStorage.setItem(CONFIG.STORAGE_KEY, 'true');
        }
      }
    },

    hidePopup() {
      const popupOverlay = this.$('zengaz-popup-overlay');
      if (popupOverlay) {
        popupOverlay.style.display = 'none';

        // Unlock body scroll
        document.body.classList.remove('popup-open');
      }
    },

    validateForm() {
      const fields = [
        { id: 'popupFirstName', label: this.$('popupFirstName')?.previousElementSibling },
        { id: 'popupLastName', label: this.$('popupLastName')?.previousElementSibling },
        { id: 'popupEmail', label: this.$('popupEmail')?.previousElementSibling },
        { id: 'popupCountry', label: this.$('popupCountry')?.previousElementSibling },
      ];

      let isValid = true;
      let firstInvalidField = null;

      fields.forEach(({ id, label }) => {
        const field = this.$(id);
        if (!field) return;

        // Remove previous validation states
        field.classList.remove('is-invalid');
        if (label) label.classList.remove('is-invalid');

        // Validate field
        if (!field.value || !field.value.trim()) {
          isValid = false;
          field.classList.add('is-invalid');
          if (label) label.classList.add('is-invalid');
          if (!firstInvalidField) firstInvalidField = field;
        }

        // Email validation
        if (id === 'popupEmail' && field.value && field.value.trim()) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(field.value)) {
            isValid = false;
            field.classList.add('is-invalid');
            if (label) label.classList.add('is-invalid');
            if (!firstInvalidField) firstInvalidField = field;
          }
        }
      });

      // Validate phone with intl-tel-input
      if (!validatePhoneField()) {
        isValid = false;
        if (!firstInvalidField) firstInvalidField = this.$('popupPhone');
      }

      if (!isValid && firstInvalidField) {
        firstInvalidField.focus();
        firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return isValid;
    },

    async handleSubmit(event) {
      event.preventDefault();

      // Validate form
      if (!this.validateForm()) {
        return;
      }

      const submitButton = this.$('zengaz-popup-form').querySelector('button[type="submit"]');
      const originalButtonText = submitButton.textContent;
      const errorHolder = this.$('zengaz-popup-error');

      this.setFormFieldsDisabled(true);
      submitButton.textContent = 'Processing...';
      this.hide(errorHolder);

      // Use E.164 format from intl-tel-input
      const phoneNumber = itiInstance ? itiInstance.getNumber() : this.$('popupPhone').value;

      const formData = {
        brand: CONFIG.BRAND,
        leadSourceDetailsExpanded: 'Prize Popup',
        leadType: this.state.userType,
        submissionId: (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2),
        pageUrl: window.location.href,
        confirm_email: (this.$('zengaz-popup-form').querySelector('[name="confirm_email"]') || {}).value || '',
        turnstileToken: (this.$('zengaz-popup-form').querySelector('[name="cf-turnstile-response"]') || {}).value || '',
        firstName: this.$('popupFirstName').value,
        lastName: this.$('popupLastName').value,
        email: this.$('popupEmail').value,
        phone: phoneNumber,
        country: this.$('popupCountry').value,
      };

      try {
        const response = await fetch(CONFIG.API_BASE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        });

        const result = await response.json().catch(() => ({}));

        if (!response.ok) {
          if (window.turnstile) { try { window.turnstile.reset(this.$('zengaz-popup-form').querySelector('.cf-turnstile')); } catch (e) {} }
            throw new Error(result.error || 'An unexpected error occurred.');
        }

        if (result.coupon_code) {
          const couponCodeHolder = this.$('zengaz-coupon-code-display');
          if (couponCodeHolder) couponCodeHolder.textContent = result.coupon_code;
          this.showView('zengaz-popup-success-view');
        } else {
          this.showView('zengaz-popup-business-success-view');
        }
      } catch (error) {
        console.error('[Popup] Submission error:', error);
        if (errorHolder) {
          errorHolder.textContent = error.message;
          this.show(errorHolder);
        }
      } finally {
        this.setFormFieldsDisabled(false);
        submitButton.textContent = originalButtonText;
      }
    },
  };

  // Initialize popup when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      PopupManager.init();
    });
  } else {
    PopupManager.init();
  }
})();

